<template>
  <el-container>
    <el-header class="main-head">
      <div class="logo-name" :class="{ coll: isColl }">
        <i class="el-icon-finished" v-show="isColl"></i>
        <transition name="bounce">
          <el-col v-show="!isColl" style="font-size:16px;">吉首城市供水总公司</el-col>
        </transition>
      </div>
      <div class="head-tools">
        <i class="el-icon-s-fold hover" @click="close"></i>
      </div>
      <div class="user-info">
        <span style="padding-right:30px">欢迎，{{ userName }}</span>
        <div @click="handleLogOut" style="cursor: pointer;">
          <i class="el-icon-error"></i>
          <span>安全退出</span>
        </div>
      </div>
    </el-header>
    <el-container>
      <el-aside>
        <el-nav :isCollapse.sync="isColl" :menu="menuList"></el-nav>
      </el-aside>
      <el-main style="background-color: #ffffff">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import QS from 'qs'
import Nav from "@/components/el-nav";
import { logout } from '@/axios/api'
import { convertCase } from '@/axios/util'
export default {
  components: {
    [Nav.name]: Nav
  },
  data() {
    return {
      isColl: false,
      userName: '',
      menuList:[]
    };
  },
  methods: {
    close() {
      this.isColl = !this.isColl;
    },
    handleLogOut(){
      logout().then(res => {
        localStorage.removeItem("admin")
      });
    }
  },
  mounted(){
    let user = QS.parse((atob(convertCase(localStorage.getItem("admin")).split('').reverse().join(''))));
    
    this.userName = user.name;
    this.menuList = user.menuList
  }
};
</script>

<style>
.bounce-enter-active {
  animation: bounce-in 0s;
}
.bounce-leave-active {
  animation: bounce-in 0s reverse;
}
@keyframes bounce-in {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.logo-name.coll {
  width: 64px;
}
.el-icon-s-fold.hover {
  cursor: pointer;
}
.head-tools {
  position: absolute;
  left: 200px;
  right: 0;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  font-size: 20px;
  padding: 0 20px;
}
.main-head {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
}
.logo-name {
  width: 200px;
  height: 60px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  background-color: #409eff !important;
  transition: width 0.32s;
  will-change: width;
  color: #ffffff;
  font-size: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.el-container {
  width: 100%;
  height: 100%;
}
.el-header {
  background-color: #409eff;
  color: #333;
  text-align: center;
  height: 60px;
  padding: 0;
}

.el-aside {
  background-color: #d3dce6;
  color: #333;
  text-align: center;
  height: 100%;
  background-color: #20222a;
  width: auto !important;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
}
.user-info {
  width: auto;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  right: 40px;
  color: #ffffff;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/views/Main.vue